import { render } from "./segregation_master.vue?vue&type=template&id=0d9387f7&scoped=true"
import script from "./segregation_master.vue?vue&type=script&lang=js"
export * from "./segregation_master.vue?vue&type=script&lang=js"

import "./segregation_master.vue?vue&type=style&index=0&id=0d9387f7&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9387f7"]])

export default __exports__